import { SWRConfiguration, SWRResponse } from 'swr';
import { GetPicfsResponse, GetPicfs } from '../../api/dtos';
import { useMemo } from 'react';
import { useGet } from '@ngt/opms';

export const INVESTIGATOR_LOOKUP_OTHER = "other";

const getData = (response?: SWRResponse<GetPicfsResponse, GetPicfsResponse>) => response?.data?.picfs;

const getError = (response?: SWRResponse<GetPicfsResponse, GetPicfsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const usePicfs = (institutionCode?: string, patientConsentId?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return (institutionCode || patientConsentId) ?
            () => {
                return new GetPicfs({ instCode: institutionCode, patientConsentId });
            } :
            undefined;
    }, [institutionCode, patientConsentId])

    return useGet(request, { getData, getError }, configuration);
};

export default usePicfs;